import React from "react";
import RentsetupForms from "./RentSetupForms";

const EditRentsetup = () => {

    return (
        <RentsetupForms type="Edit" />
    )
}

export default EditRentsetup